<template>
  <template-order-detail-page></template-order-detail-page>
</template>

<script lang="ts">

import templateOrderDetailPage from '@/app-template/lib/pages/OrderDetailPage.vue';

export default {
  name: "OrderDetailPage",
  components: { templateOrderDetailPage },
};
</script>